import './ripple.scss';

function createRipple(event) {
    const button = event.currentTarget;
    
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    const offLeft = (button.getClientRects()[0].left).toFixed();
    const offTop = (button.getClientRects()[0].top).toFixed();

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - offLeft - radius}px`;
    circle.style.top = `${event.clientY - offTop - radius}px`;
    circle.classList.add("ripple");
    const ripple = button.getElementsByClassName("ripple")[0];

    if (ripple) {
        ripple.remove();
    }

    button.appendChild(circle);
    
}

const buttons = document.getElementsByTagName("button");
for (const button of buttons) {
    button.addEventListener("click", createRipple);
}
